import { render, staticRenderFns } from "./lenovoMaterial.vue?vue&type=template&id=cbd6c900&scoped=true&"
import script from "./lenovoMaterial.vue?vue&type=script&lang=js&"
export * from "./lenovoMaterial.vue?vue&type=script&lang=js&"
import style0 from "./lenovoMaterial.vue?vue&type=style&index=0&id=cbd6c900&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd6c900",
  null
  
)

export default component.exports